<template>
    <div>
        <content-header v-bind:title="$t(ftitle)"></content-header>
        <loading v-bind:dspin="!contentLoaded"></loading>

        <div class="flow-main-content-1" v-if="contentLoaded">
            <div v-if="physicians.length > 0" class="w3-container">
              <div class="w3-col w-45pc">
                <div class="w3-left w3-margin w3-col w-5pc">
                  <i class="fa fa-user-md w3-margin-right w3-xlarge flow-blue-color"></i>
                </div>
                <div class="w3-show-inline-block w3-col w-45pc">
                  <flow-select :items="physicians"
                               :valueKey="'name'"
                               :valueKeyIndex="'id'"
                               :callback="showPatients"
                               :preSelectedItem="activePhysician"
                               class="zero-top w3-show-inline-block">
                  </flow-select>
                </div>
              </div>
            </div>


            <div class="w3-container w3-margin-top">

                <div v-if="showAvgChart && !isAdmin" id="chart" class="w3-col w-45pc w3-margin-right w3-margin-bottom">
                    <div class="flow-card blue-top w3-animate-opacity" :style="!isNormal ? 'height: 400px !important; overflow-y: auto' : ''">

                        <h4 class="flow-blue-color w3-margin">
                            <i class="fa fa-chart-line flow-margin-right"></i>
                            {{ $t('dataAnalytics') }}
                        </h4>

                        <div v-if="!chartData.data || chartData.data.length === 0" style="min-height: 400px"
                             class="w3-margin-top">
                            <h4 class="w3-margin w3-center w3-margin-top">
                                {{ $t('noData') }}
                            </h4>
                        </div>

                        <div v-else>
                            <flow-line-chart :canvas-id="'avgWaitChart'" :data="chartData.data"
                                             :xlabels="chartData.xlabels" :chartHeading="$t('avgChartLegend')"></flow-line-chart>
                            <canvas id="avgWaitChart" class="w3-margin-bottom w3-padding w3-center"></canvas>
                        </div>

                    </div>
                </div>

                <div v-if="!isNormal" id="fastrack-add-new-patient" class="flow-card blue-top w3-padding w3-col w-45pc w3-margin-right w3-margin-bottom" :style="!isNormal ? 'height: 400px !important; overflow-y: auto' : ''">
                    <h4 class="flow-blue-color w3-left zero-left">
                        <i class="fa fa-user-plus flow-margin-right"></i>
                        {{ $t("addNewPatient") }}
                    </h4>
                    <NewPatientDashboard :specialWard="specialWard"
                                         :specialWardsIds="specialWardsIds"
                                         :isDH="isDH">
                    </NewPatientDashboard>
                </div>

                <div v-if="showPatReport" id="pats-for-phy-report" class="w3-col w-45pc w3-margin-right w3-margin-bottom">
                    <div class="flow-card blue-top w3-animate-opacity w3-padding" style="height: 500px; overflow-y: auto;"
                         :style="!isNormal ? 'height: 400px !important;' : ''">

                        <div class="w3-margin-top">
                            <!--PHYSICIANS SECTION-->
                            <div class="w3-margin-bottom">
                              <h4 v-if="activePhysician"
                                  class="flow-blue-color w3-animate-opacity zero-top zero-bottom w3-left">
                                  {{activePhysician.name}}
                              </h4>
                                <vue-json-to-csv
                                        v-if="!isIE() && patients.length !== 0"
                                        :json-data="exportPatients"
                                        :labels="{ time: { title: $t('time') }, name: { title: $t('name') }, internalIds: { title: $t('patientID') }, physician: { title: $t('physician') }, physicianId: {title: $t('physician')+'ID'},status: { title: $t('status') } }"
                                        :csv-title="title"
                                        :separator="','"
                                        @success="exportSuccess">
                                    <button class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium   w3-show-inline-block w3-right w3-xlarge flow-margin-left"
                                            :title="$t('exportPatients')">
                                        <i class="fa fa-file-csv flow-green-active-color">
                                            <!--<span><b class="flow-margin-left">{{$t('exportPatients')}}</b></span>-->
                                        </i>
                                    </button>
                                </vue-json-to-csv>
                                <button v-if="patients.length !== 0"
                                        class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-show-inline-block w3-right w3-xlarge"
                                        @click="exportPDF" title="PDF">
                                    <i class="fa fa-file-pdf w3-text-red">
                                        <!--<span><b class="flow-margin-left">{{$t('exportPatientstoPDF')}}</b></span>-->
                                    </i>
                                </button>
                            </div>

                            <!--PATIENTS SECTION-->
                            <table class="w3-table w3-bordered flow-table patients-table w3-margin-top">
                                <thead class="flow-blue-color">
                                <th>{{ $t("time") }}</th>
                                <th>{{ $t("name") }}</th>
                                <th>{{ $t("status") }}</th>
                                </thead>
                                <tbody v-if="patients.length === 0">
                                <tr>
                                    <td colspan="8" class="w3-center flow-blue-color">
                                        <b class="font-size-1pt25em">{{$t("noPatients")}}</b>
                                    </td>
                                </tr>
                                </tbody>
                                <tbody v-else>
                                <tr v-for="patient in patients"
                                    v-bind:id="patient.patientId">
                                    <td>
                                        <span>{{patient.appointmentTime}}</span>
                                    </td>

                                    <td>
                                        <span>{{patient.patientName}}</span>
                                    </td>

                                    <td>
                                <span>
                                <patient-status class="w3-show-inline-block w3-margin-right" :status="patient.status"
                                                :showMarker="true"></patient-status>
                                </span>
                                    </td>
                                </tr>
                                </tbody>

                            </table>
                        </div>
                    </div>
                </div>

                <div v-if="isAdmin" id="wr-status"
                     class="flow-card blue-top w3-padding w3-col w-45pc w3-margin-bottom w3-margin-right"
                     :style="!isNormal ? 'height: 400px !important; overflow-y: auto' : ''">
                    <h4 class="flow-blue-color w3-left zero-left">
                        <i class="fa fa-chair flow-margin-right"></i>
                        {{ $t("WRStatus") }}
                    </h4>

                    <loading v-bind:dspin="!wrCapacityLoaded"></loading>

                    <div v-if="wrCapacityLoaded" v-for="wr in waitingRooms" class="w3-margin-top">
                        <WRStatus v-if="wrToShow.length===0 || wrToShow.includes(wr.id)"
                                  :wr="wr" :patientsNumber="wrPatients[wr.id] ? wrPatients[wr.id] : 0"
                                  :wrCapacity="wrCapacity[wr.id]"></WRStatus>
                    </div>
                </div>


                <div v-if="!isNormal" id="lost-badges"
                     class="flow-card blue-top w3-padding w3-col w-45pc w3-margin-bottom w3-margin-right"
                     :style="!isNormal ? 'height: 400px !important; overflow-y: auto' : ''">
                    <h4 class="flow-blue-color w3-left zero-left">
                        <i class="fa fa-tags flow-margin-right"></i>
                        {{ $t("lostBadges") }} CDC
                    </h4>

                    <loading v-bind:dspin="!badgesLoaded"></loading>

                    <div v-if="badgesLoaded">
                        <LostBadges :badges="lostBadges"></LostBadges>
                    </div>
                </div>



                <div v-if="!isNormal" id="logged-in-chart" class="w3-col w-45pc w3-margin-right w3-margin-bottom">
                    <div class="flow-card blue-top w3-animate-opacity" :style="!isNormal ? 'height: 400px !important; overflow-y: auto' : ''">

                        <h4 class="flow-blue-color w3-margin">
                            <i class="fa fa-chart-line flow-margin-right"></i>
                            {{ $t('dataAnalytics') }}
                        </h4>

                        <div v-if="!loggedInChartData.data || loggedInChartData.data.length === 0" style="min-height: 400px"
                             class="w3-margin-top">
                            <h4 class="w3-margin w3-center w3-margin-top">
                                {{ $t('noData') }}
                            </h4>
                        </div>

                        <div v-else>
                            <flow-line-chart :canvas-id="'loggedInChart'" :data="loggedInChartData.data"
                                             :xlabels="loggedInChartData.xlabels" :chartHeading="$t('mobileUsersChart')"></flow-line-chart>
                            <canvas id="loggedInChart" class="w3-margin-bottom w3-padding w3-center"></canvas>
                        </div>

                    </div>
                </div>

            </div>
        </div>


    </div>
</template>
<script>
    import ContentHeader from "../components/common/ContentHeader";
    import Loading from "../components/common/Loading";
    import PatientStatus from "../components/common/PatientStatus";
    import FlowSelect from "../components/common/FlowSelect";
    import NewPatientDashboard from "../components/patient/NewPatientDashboard";
    import Vue from 'vue';
    import {EventBus} from "../main";
    import VueJsonToCsv from 'vue-json-to-csv';
    import jsPDF from 'jspdf';
    import FlowLineChart from "../components/chart/FlowLineChart";
    import WRStatus from "../components/wr/WRStatus";
    import LostBadges from "../components/badge/lostBadges";

    require('jspdf-autotable');

    let frc = Vue.prototype.$frc;

    export default {
        name: "Dashboard",
        components: {
            FlowLineChart, WRStatus, LostBadges,
            Loading, ContentHeader, PatientStatus, VueJsonToCsv, FlowSelect, jsPDF, NewPatientDashboard
        },
        props: ['ftitle'],
        data: function () {
            return {
                contentLoaded: false,
                wrCapacityLoaded: false,
                badgesLoaded: false,
                physicians: [],
                patients: [],
                exportPatients: [],
                activePhysician: undefined,
                title: "",
                chartData: {
                    data: undefined,
                    xlabels: undefined
                },
                loggedInChartData: {
                    data: undefined,
                    xlabels: undefined
                },
                monthMap: {
                    '1': 'jan',
                    '2': 'feb',
                    '3': 'mar',
                    '4': 'apr',
                    '5': 'may',
                    '6': 'jun',
                    '7': 'jul',
                    '8': 'aug',
                    '9': 'sep',
                    '10': 'oct',
                    '11': 'nov',
                    '12': 'dec'
                },
                specialWardsIds: [],
                specialWard: false,
                isDH: false,
                wards: [],
                waitingRooms: [],
                allPatients: [],
                wrPatients: {},
                wrToShow: [],
                wrCapacity: {},
                refreshIntervalId: undefined,
                lostBadges: []
            }
        },
        watch: {
          activePhysician(o, n) {
            if (!this.isAdmin) {
              this.getAvgWaitData();
            }
          }
        },
        computed: {
            isNormal() {
                return Vue.isNormal(Vue.prototype.$currentUser.user.role);
            },
            isAdmin() {
                return Vue.isAdmin(Vue.prototype.$currentUser.user.role);
            },
            showAvgChart() {
                return this.activePhysician;
            },
            showPatReport() {
                return ((this.isNormal && this.activePhysician !== undefined) || !this.isNormal);
            }
        },
        mounted() {
            this.checkWard();
            this.isDH = Vue.prototype.$showStatusOverviewMenu;
            var user = Vue.prototype.$currentUser.user;
            frc.getApplicationSetting("UI","specialWardsIds").then(response => {
                var splitWards = response.data.split(","); 
                this.specialWardsIds = splitWards;
            })
            if (this.isNormal) {
              const app = this;
              for (let i in user.physicians) {
                frc.getPhysicianWithId(user.physicians[i]).then(function (res) {
                  let physician = res.data;
                  app.physicians.push(physician);
                  if (!app.activePhysician) {
                    app.activePhysician = physician;
                    app.title = "Export-" + app.yyyymmdd() + "-" + app.activePhysician.name;
                    app.getPatientsForPhysician(app.activePhysician.ward.id, app.activePhysician.id);
                    app.contentLoaded = true;
                  }
                })
              }
            } else {
              this.getPhysiciansInWard();
              EventBus.$on("wardUpdated", this.onWardUpdate);
            }
            if (this.isAdmin) {
                this.getWards();
                this.getWRToShow();
                this.refreshIntervalId = setInterval(this.refreshPatients, 10000);
            }
            if (!this.isNormal) {
                this.getLostBadges();
                this.getLoggedInChartData();
            }
            if (!this.isAdmin) {
                this.getAvgWaitData();
            }
        },
        beforeDestroy() {
            EventBus.$off("wardUpdated", this.onWardUpdate);
            clearInterval(this.refreshIntervalId);
        },
        methods: {
            refreshPatients() {
                this.getPatients(this.wards, this.waitingRooms);
            },
            onWardUpdate() {
                this.getPhysiciansInWard();
                this.checkWard();
                this.isDH = Vue.prototype.$showStatusOverviewMenu;
                if (this.isAdmin) {
                    this.getWards();
                }
            },
            getWards() {
                var app = this;
                app.wrCapacityLoaded = false;
                frc.getWards().then(function (res) {
                    app.wards = res.data;
                    app.getWRs(res.data);
                }).catch(function (ex) {
                    console.log(ex);
                });
            },
            getWRToShow() {
                var app = this;
                frc.getApplicationSetting("WaitingAreaCapacity", "toShow").then(function (res) {
                    var toShow = res.data;
                    var wrToShow = toShow === "" ? [] : toShow.split(',');
                    app.wrToShow = wrToShow;
                    if (wrToShow.length === 0) {
                        frc.getAllWaitingAreas().then(function (res) {
                            var wrs = res.data;
                            var showWR = [];
                            for (var i=0;i<wrs.length;i++) {
                                showWR.push(wrs[i].id);
                            }
                            app.getCapacities(showWR);
                        }).catch(function (ex) {
                            console.log(ex);
                        });
                    }
                    else {
                        app.getCapacities(wrToShow);
                    }
                }).catch(function (ex) {
                    console.log(ex);
                });
            },
            getCapacities (wrToShow) {
                var app = this;
                for (let i=0; i< wrToShow.length; i++) {
                    frc.getApplicationSetting("WaitingAreaCapacity", wrToShow[i]).then(function (res) {
                        app.wrCapacity[wrToShow[i]] = res.data;
                    }).catch(function (ex) {
                        console.log(ex);
                    });
                }
            },
            getWRs(wards) {
                var app = this;
                frc.getAllWaitingAreas().then(function (res) {
                    app.waitingRooms = res.data;
                    Vue.sortByKey(app.waitingRooms, 'displayName');
                    app.getPatients(wards, res.data);
                    app.wrCapacityLoaded = true;
                }).catch(function (ex) {
                    console.log(ex);
                });
            },
            getLostBadges() {
                var app = this;
                app.badgesLoaded = false;
                app.lostBadges = [];
                frc.getLostBadges().then(function (res) {
                    var badges = res.data;
                    for (var i = 0; i < badges.length; i++) {
                        if (badges[i].status === "SUCCESS") {
                            app.lostBadges.push(badges[i]);
                        }
                    }
                    Vue.sortByKey(app.lostBadges, 'lastSeenAt');
                    app.lostBadges.reverse();
                    app.badgesLoaded = true;
                }).catch(function (ex) {
                    console.log(ex);
                    app.badgesLoaded = true;
                });
            },
            getPatients(wards, wrs) {
                var app = this;
                app.allPatients = [];
                for (let i = 0; i < wards.length; i++) {
                    frc.getPatientsForWard(wards[i].id, null, null, ["AtWaitingArea"]).then(function (res) {
                        var pat = res.data;
                        for (var j = 0; j < pat.length; j++) {
                            app.allPatients.push(pat[j]);
                        }
                        app.mapPatientsNumberToWr(wrs, res.data);
                    }).catch(function (ex) {
                        console.log(ex);
                    });
                }
            },
            mapPatientsNumberToWr(wrs, patients) {
                for (var i = 0; i < wrs.length; i++) {
                    var wr = wrs[i];
                    var counter = 0;
                    for (var j = 0; j < patients.length; j++) {
                        if (patients[j].latestPosition.id === wr.id) {
                            counter++;
                            this.wrPatients[wr.id] = counter;
                        }
                    }
                    this.$forceUpdate();
                }
            },
            checkWard() {
                this.specialWard = this.specialWardsIds.includes(Vue.prototype.$currentWard.id);
            },
            getPatientsForPhysician(wardId, physicianId) {
                const app = this;
                frc.getPatientsForPhysician(wardId, physicianId).then(function (res) {
                    app.patients = res.data;
                    app.contentLoaded = true;
                    app.fillExportPatients(app.patients);
                }).catch(function (ex) {
                    console.log(ex);
                })
            },
            fillExportPatients(patients) {
                this.exportPatients = [];
                for (var i = 0; i < patients.length; i++) {
                    this.exportPatients.push({
                        id: patients[i].patientId,
                        time: patients[i].appointmentTime,
                        name: patients[i].patientName,
                        status: patients[i].status,
                        physician: patients[i].physician.name,
                        physicianId: patients[i].physician.id,
                        internalIds: patients[i].internalIds
                    })
                }
            },
            getPhysiciansInWard() {
                const app = this;
                frc.getPhysiciansInWard(Vue.prototype.$currentWard.id).then(function (res) {
                    app.physicians = res.data;
                    Vue.sortByKey(app.physicians, 'name');
                    app.contentLoaded = true;
                }).catch(function (ex) {
                    console.log(ex);
                })
            },
            showPatients(physician) {
                this.title = "Export-" + this.yyyymmdd() + "-" + physician.name;
                this.activePhysician = physician;
                this.getPatientsForPhysician(Vue.prototype.$currentWard.id, physician.id);
            },
            exportSuccess() {
                Vue.notifySuccess({title: this.$t("exportSuccessful")});
            },
            yyyymmdd() {
                var now = new Date();
                var y = now.getFullYear();
                var m = now.getMonth() + 1;
                var d = now.getDate();
                return '' + y + (m < 10 ? '0' : '') + m + (d < 10 ? '0' : '') + d;
            },
            exportPDF() {
                var app = this;
                var columns = [
                    {title: app.$t('appointment') + app.$t('time'), dataKey: "time"},
                    {title: app.$t('name'), dataKey: "name"},
                    {title: app.$t('patientID'), dataKey: "internalIds"},
                    {title: app.$t('physician'), dataKey: "physician"},
                    {title: app.$t('physician') + 'ID', dataKey: "physicianId"},
                    {title: app.$t('status'), dataKey: "status"}
                ];
                var doc = new jsPDF('landscape');
                doc.autoTable(columns, app.exportPatients, {
                    theme: 'striped',
                    headerStyles: {fillColor: [9, 78, 119]},
                    styles: {
                        overflow: 'linebreak'
                    }
                });
                doc.save(app.title + ".pdf");
            },
            isIE() {
                var ua = navigator.userAgent;
                /* MSIE used to detect old browsers and Trident used to newer ones*/
                var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

                return is_ie;
            },
            getAvgWaitData() {
                var phy = this.activePhysician;
                if (!phy) {
                    this.chartData = {
                        data: [],
                        xlabels: []
                    };
                    return;
                }
                var avgs = [];
                var app = this;
                frc.getAverageWaitingForPhysician(phy.id).then(function (res) {
                    avgs = res.data;
                    app.setAvgWaitData(avgs);
                }).catch(function (ex) {
                    avgs = [];
                    console.log(ex);
                });

            },
            setAvgWaitData(raw) {
                raw.sort(function (a, b) {
                    var ma = parseInt(a.month);
                    var mb = parseInt(b.month);

                    var ya = parseInt(a.year);
                    var yb = parseInt(b.year);

                    if (ya === yb) {
                        if (ma > mb) return 1;
                        else return -1;
                    }

                    if (ya > yb) {
                        return 1;
                    }

                    return -1;
                });


                var xaxis = [];
                var app = this;
                var avgs = [];

                raw.forEach(function (r) {
                    var im = parseInt(r.month);
                    var iy = parseInt(r.year);

                    r.label = app.$t('months')[app.monthMap[im]] + " " + iy;
                    r.waitInMins = Math.round(r.averageWaitInSeconds / 60);
                    xaxis.push(r.label);
                    avgs.push(r.waitInMins);
                });

                this.chartData.data = avgs;
                this.chartData.xlabels = xaxis;

                console.log("After processing", raw, this.chartData);
            },
            getLoggedInChartData() {
                var avgs = [];
                var app = this;
                frc.getMobileUsers().then(function (res) {
                    avgs = res.data;
                    app.setLoggedInChartData(avgs);
                }).catch(function (ex) {
                    avgs = [];
                    console.log(ex);
                });

            },
            setLoggedInChartData(raw) {
                raw.sort(function (a, b) {
                    var ma = parseInt(a.month);
                    var mb = parseInt(b.month);

                    if (ma > mb) return 1;
                    else return -1;
                });


                var xaxis = [];
                var app = this;
                var avgs = [];

                raw.forEach(function (r) {
                    var im = parseInt(r.month);

                    r.label = app.$t('months')[app.monthMap[im]];
                    xaxis.push(r.label);
                    avgs.push(r.count);
                });

                this.loggedInChartData.data = avgs;
                this.loggedInChartData.xlabels = xaxis;
            },
        }
    }

</script>

<style scoped>

</style>